module.exports = __webpack_public_path__ + "img/bubble-chart.6daf680e.png";